import styles from './PassChange.module.css'
import React, {useRef, useState} from "react";
import InputItem from "../../FormTemplate/InputItem/InputItem";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import WaitLoader from "../../WaitLoader/WaitLoader";
import useApiQuery from "../../ApiQuery/UseApiQuery";

interface PassChangeInt
{
    oldPass:string
    newPass:string
    confirmPass:string
}
export default function PassChange()
{
    const changePassData = useRef<PassChangeInt>()
    const [ldrChangePass,rsChangePass,exChangePass] = useApiQuery("/auth/pass/change","post",changePassData);
    const errorLineRef = useRef<ErrorLineItemRef>(null)
    const [passChange, setPassChange] = useState<PassChangeInt>({
        oldPass:"",
        confirmPass:"",
        newPass:""
    })

    const passCheck = (pass: string)=>{
        if(pass?.length< 8 || pass?.length>20)
        {
            if(errorLineRef?.current)errorLineRef.current.show("Не корректная длина пароля",true,2000)
            return false
        }
        let count = (pass.match(/[0-9]/gui) || []).length;
        //console.log(`count  num ${count}`)
        if(count < 3)
        {
            if(errorLineRef?.current)errorLineRef.current.show("Пароль должен содержать как минимум 3 цифры",true,2000)
            return false
        }


        return true
    }

    const handleChange = () =>{
        if( !passCheck(passChange?.newPass)) return
        if(passChange?.newPass !== passChange?.confirmPass)
        {
            if(errorLineRef?.current)errorLineRef?.current?.show("Подтверждение пароля не совпадает", true,2000)
            return
        }

        changePassData.current = {
            oldPass: passChange?.oldPass,
            confirmPass: passChange?.confirmPass,
            newPass: passChange?.newPass
        }
        exChangePass().then((e)=>{
            if(e?.success)
            {
                if(errorLineRef?.current)errorLineRef?.current?.show("Пароль сменен",false,2000)
                return
            }
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,2000)
        }).catch((e)=>{
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,2000)

        })


    }

    return(
        <div className={styles.mainCont}>
            <div className={styles.title}>Пароль должен быть не менее 8 и не более 20 символов, содержать не менее 3-х цифр</div>

            <div className={styles.lnRow}>
                <InputItem
                    title={"Старый пароль"}
                    val={passChange?.oldPass}
                    placeHolder={"Старый пароль"}
                    titleShift={1}
                    inputType={3}
                    info={"Старый пароль"}
                    mode={"ei"}
                    regExp={/^.+$/ui}
                    onChange={(e)=> setPassChange({...passChange,oldPass: e})}
                    onBlur={(e)=>{
                        if(! e?.length)
                        {
                            setPassChange({...passChange,oldPass: ""})
                            return

                        }
                        setPassChange({...passChange,oldPass: e?.trim()})
                    }}


                ></InputItem>
                <InputItem
                    title={"Новый пароль"}
                    val={passChange?.newPass}
                    placeHolder={"Новый пароль"}
                    titleShift={1}
                    inputType={3}
                    info={"Новый пароль"}
                    mode={"ei"}
                    regExp={/^[a-z0-9!&#$]{8,20}$/ui}
                    onChange={(e)=> setPassChange({...passChange,newPass: e})}
                    onBlur={(e)=>{
                        if(! e?.length)
                        {
                            setPassChange({...passChange,newPass: ""})
                            return

                        }
                        setPassChange({...passChange,newPass: e?.trim()})
                    }}


                ></InputItem>
                <InputItem
                    title={"Повтор пароль"}
                    val={passChange?.confirmPass}
                    placeHolder={"Повтор пароль"}
                    titleShift={1}
                    inputType={3}
                    info={"Повтор новый пароль"}
                    mode={"ei"}
                    regExp={/^.+$/ui}
                    onChange={(e)=> setPassChange({...passChange,confirmPass: e})}
                    onBlur={(e)=>{
                        if(! e?.length)
                        {
                            setPassChange({...passChange,confirmPass: ""})
                            return

                        }
                        setPassChange({...passChange,confirmPass: e?.trim()})
                    }}


                ></InputItem>

            </div>

            <div style={{height:"25px"}}>
                <ErrorLineItem ref={errorLineRef} ></ErrorLineItem>
            </div>
            <div className={styles.btnCont}>
                <button type="button" className="btn btn-secondary "
                        onClick={()=>handleChange()}
                >Сменить</button>


            </div>


        </div>
    )
}